const formatCurrency = (value: number | undefined) => value?.toFixed(2);

export default formatCurrency;
